export default "__VITE_ASSET__C38Wx2Pp__"